var _defs, _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgGes = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_2",
    "data-name": "Calque 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 84.32 85.41",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-5",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.5,
    dy: 0.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur",
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#081221",
    floodOpacity: 0.25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.84,49.47l-5.84-12.31c1.78-1.25,3.25-2.98,4.18-5.08,2.57-5.81.26-12.56-5.14-15.64-1.16-2.97-3.45-5.42-6.49-6.76-3.33-1.47-7.1-1.36-10.29.17-1.83-.27-3.69-.13-5.45.43-5.3-1.5-11.04,1.09-13.33,6.27-.87,1.96-1.12,4.04-.85,6.03-3.92.17-7.61,2.51-9.3,6.34-1.67,3.79-.96,8.15,1.63,11.21.83,2.67,2.77,4.88,5.43,6.06,1.01.45,2.07.71,3.13.8l-4.45,10.06,2.89,7.47,8.94,3.95h0s8.95,3.97,8.95,3.97l.9.4,8.95,3.96,7.47-2.89,8.71-19.71-.06-4.72Z",
    fill: "#3cf",
    filter: "url(#drop-shadow-5)",
    strokeWidth: 0
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M51.65,30.76l-1.35,3.05c1.29.13,2.6-.32,3.56-1.28l.24-.23.32.09c2.62.75,5.44-.57,6.54-3.07,1.23-2.78-.03-6.03-2.81-7.26-.5-.22-1.03-.37-1.57-.43l-.51-.06v-.52c.07-2.24-1.22-4.27-3.26-5.17-2.06-.91-4.52-.45-6.12,1.15l-.29.29-.37-.19c-.11-.06-.22-.11-.33-.16-1.81-.8-3.92-.56-5.51.62l-.35.26-.34-.27c-.3-.24-.62-.43-.95-.57-2.24-.99-4.86.03-5.85,2.26-.99,2.24.03,4.86,2.26,5.85.76.34,1.6.45,2.43.33l.61-.09.04.62c.09,1.56.97,2.93,2.33,3.66l5.19-11.74,6.1,12.86Z",
    fill: "none",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.49,33.89c-.08-.04-.16-.07-.24-.1l-.39-.14.02-.42c.08-1.58-.85-3.07-2.3-3.71s-3.1-.34-4.23.74l-.37.36-.39-.34c-.29-.25-.61-.46-.97-.61-1.95-.86-4.23.02-5.09,1.97-.77,1.75-.13,3.83,1.5,4.84l.28.18v.33c-.07,1.28.65,2.44,1.82,2.96,1.09.48,2.37.28,3.27-.5l.91-.79.03,1.21c.03,1.19.75,2.27,1.83,2.75.8.35,1.68.35,2.46.01l3.35-7.57c-.39-.5-.89-.9-1.48-1.16Z",
    fill: "none",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.04,25.99l-.04-.62-.61.09c-.83.12-1.67,0-2.43-.33-2.24-.99-3.25-3.61-2.26-5.85.99-2.24,3.61-3.25,5.85-2.26.33.14.64.34.95.57l.34.27.35-.26c1.59-1.18,3.7-1.42,5.51-.62.11.05.22.11.33.16l.37.19.29-.29c1.6-1.6,4.05-2.06,6.12-1.15,2.05.9,3.33,2.94,3.28,5.17v.52s.5.06.5.06c.54.06,1.07.21,1.57.43,2.78,1.23,4.04,4.48,2.81,7.26-1.1,2.5-3.92,3.82-6.54,3.07l-.32-.09-.24.23c-.96.96-2.27,1.41-3.56,1.28l-.48,1.08c1.64.28,3.32-.19,4.6-1.32,3.07.72,6.28-.87,7.57-3.78,1.48-3.35-.04-7.27-3.39-8.75-.45-.2-.92-.35-1.4-.44-.12-2.5-1.63-4.72-3.95-5.74-2.36-1.04-5.16-.6-7.08,1.1l-.04-.02c-2.05-.91-4.43-.71-6.3.51-.27-.18-.56-.34-.85-.47-2.81-1.24-6.1.03-7.34,2.84s.03,6.1,2.84,7.34c.78.34,1.62.5,2.47.47.28,1.74,1.36,3.24,2.94,4.05l.46-1.04c-1.36-.73-2.24-2.1-2.33-3.66Z",
    fill: "#252544",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.17,42.62c-1.09-.48-1.81-1.56-1.83-2.75l-.03-1.21-.91.79c-.9.78-2.18.98-3.27.5-1.17-.52-1.89-1.68-1.83-2.96v-.33s-.27-.18-.27-.18c-1.63-1.01-2.27-3.09-1.5-4.84.86-1.95,3.14-2.83,5.09-1.97.35.16.68.36.97.61l.39.34.37-.36c1.13-1.09,2.79-1.38,4.23-.74s2.37,2.13,2.3,3.71l-.02.42.39.14c.08.03.16.06.24.1.59.26,1.09.67,1.48,1.16l.51-1.15c-.42-.42-.91-.77-1.46-1.03-.07-1.89-1.22-3.63-2.97-4.4-1.71-.75-3.66-.5-5.1.64-.27-.19-.56-.35-.86-.49-2.52-1.11-5.47.03-6.58,2.55-.96,2.17-.24,4.72,1.67,6.08.05,1.62,1.01,3.05,2.51,3.71,1.19.52,2.54.46,3.67-.13.32,1.23,1.19,2.27,2.37,2.8.75.33,1.55.42,2.33.31l.59-1.33c-.77.33-1.66.34-2.46-.01Z",
    fill: "#252544",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.91,35.58l.32.68.6-1.36c-.19-.03-.38-.07-.57-.12l-.36.81Z",
    fill: "#252544",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28,59.03l6.73-15.23c-.23.07-.46.13-.69.16l-6.79,15.36,8.95,3.96.23-.52-8.44-3.73Z",
    fill: "#252544",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.03,30.77l-1.3,2.94c.19.05.38.08.58.1l1.35-3.05-6.1-12.86-5.19,11.74c.1.05.2.1.3.15.07.03.14.06.21.08l4.69-10.62,5.46,11.51Z",
    fill: "#252544",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.97,35.06l-3.35,7.57c.26-.11.51-.26.73-.44l.13-.1,2.86-6.46c-.11-.2-.23-.39-.37-.56Z",
    fill: "#252544",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.42,30.91c-.07-.03-.14-.05-.21-.08-.1-.05-.21-.1-.31-.15l-1.43,3.23c.15.15.28.31.41.47l1.53-3.47Z",
    fill: "#252544",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.73,33.72l-.47,1.05c.19.05.38.09.57.12l.48-1.08c-.19-.02-.38-.05-.58-.1Z",
    fill: "#252544",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.42,30.91l.46-1.03c-.07-.03-.14-.05-.21-.08-.1-.05-.21-.1-.3-.15l-.46,1.04c.1.05.2.1.31.15.07.03.14.05.21.08Z",
    fill: "#252544",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.49,42.09l-.13.1c-.23.18-.47.33-.73.44l-.59,1.33c.23-.04.46-.09.69-.16l.76-1.72Z",
    fill: "#252544",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.34,35.62l.55-1.24c-.13-.17-.26-.32-.41-.47l-.51,1.15c.14.18.26.36.37.56Z",
    fill: "#252544",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.73,34.59l-12.19,27.6-7.79-3.44,6.75-15.29c-.25.14-.51.26-.77.35l-6.73,15.23,8.44,3.73,12.23-27.68.24.5.36-.81c-.18-.05-.36-.11-.54-.18Z",
    fill: "#252544",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.96,31.1c-.18-.05-.36-.11-.54-.18l-1.53,3.47c.14.18.26.37.37.56l1.7-3.85Z",
    fill: "#252544",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.08,42.15l2.56-5.79c-.07-.26-.17-.51-.29-.74l-2.86,6.46.35-.29.24.35Z",
    fill: "#252544",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.59,20.62l4.82,10.16-1.22,2.77c.18.07.36.12.55.17l1.3-2.94-5.46-11.51-4.69,10.62c.18.07.36.12.55.17l4.16-9.42Z",
    fill: "#252544",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.73,34.59c.18.07.36.13.54.18l.47-1.05c-.18-.04-.37-.1-.55-.17l-.46,1.04Z",
    fill: "#252544",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.43,30.05c-.18-.04-.37-.1-.55-.17l-.46,1.03c.18.07.36.13.54.18l.46-1.05Z",
    fill: "#252544",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.64,36.36l.62-1.41c-.11-.2-.23-.38-.37-.56l-.55,1.24c.12.23.22.48.29.74Z",
    fill: "#252544",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.5,43.45l.58-1.3-.24-.35-.35.29-.76,1.72c.27-.09.52-.21.77-.35Z",
    fill: "#252544",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "53.91 47.44 54.21 46.76 49.23 36.25 48.93 36.94 53.91 47.44",
    fill: "#252544",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "37.34 63.17 37.11 63.68 36.21 63.28 36.2 63.29 45.16 67.24 45.39 66.73 37.34 63.17",
    fill: "#252544",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "37.34 63.17 36.95 63 48.69 36.43 48.93 36.94 49.23 36.25 48.91 35.58 36.82 62.93 36.44 62.76 36.21 63.28 37.11 63.68 37.34 63.17",
    fill: "#252544",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "36.44 62.76 36.82 62.93 48.91 35.58 48.67 35.07 36.44 62.76",
    fill: "#252544",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.34,63.17l8.05,3.56,8.52-19.29-4.98-10.5-11.59,26.23ZM53.53,47.95l-8.04,18.2-7.79-3.44,11.01-24.91,4.82,10.16Z",
    fill: "#252544",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "48.69 36.43 36.95 63 37.34 63.17 48.93 36.94 48.69 36.43",
    fill: "#252544",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "57.62 39.03 54.21 46.76 54.53 47.43 57.64 40.39 63.1 51.9 54.73 70.85 46.29 67.13 46.06 67.64 55.02 71.6 63.73 51.89 57.62 39.03",
    fill: "#252544",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "45.91 66.96 54.53 47.43 54.21 46.76 53.91 47.44 54.15 47.94 45.77 66.9 45.39 66.73 45.16 67.24 46.06 67.64 46.29 67.13 45.91 66.96",
    fill: "#252544",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "45.77 66.9 54.15 47.94 53.91 47.44 45.39 66.73 45.77 66.9",
    fill: "#252544",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.29,67.13l8.44,3.73,8.37-18.95-5.46-11.51-3.11,7.04.24.5-8.48,19.19ZM57.66,41.75l4.82,10.16-8.04,18.2-7.79-3.44,11.01-24.91Z",
    fill: "#252544",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "46.29 67.13 54.77 47.94 54.53 47.43 45.91 66.96 46.29 67.13",
    fill: "#252544",
    strokeWidth: 0
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgGes);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/GES.0e283c26d1f91a50b53cb811cf014aa8.svg";